import { render, staticRenderFns } from "./AttendanceOptionCallback.vue?vue&type=template&id=351cb4ab&scoped=true"
import script from "./AttendanceOptionCallback.vue?vue&type=script&lang=js"
export * from "./AttendanceOptionCallback.vue?vue&type=script&lang=js"
import style0 from "./AttendanceOptionCallback.vue?vue&type=style&index=0&id=351cb4ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351cb4ab",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSeparator,QIcon,QTooltip,QCardActions,QBtn});qInstall(component, 'directives', {ClosePopup});
